import global from "../global";
const log = global.log.getLogger("f_mtac.ui.ToastArea");
log.setLevel(log.levels.WARN);

let ToastArea = function () {
    var {Toast} = window.f_mtac_theme;
    function getToast(type, body) {
        return `
    <div class="toast text-bg-${type} d-flex" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-body">${body}</div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    `;
    }

    /* @Brief Create a new toast element and delete it from the DOM once hidden.
    // type: Set the alert style from theme-colors (eg: success, info, warning, danger, etc.)
    // body: Text or html to show in the toast.
    // options: Bootstrap toast options: {
    //    animation: boolean (true),                                     // Apply a CSS fade transition to the toast. 
    //    autohide: boolean (true except for danger and warning types),  // Automatically hide the toast after the delay.
    //    delay: number (5000)                                           // Delay in milliseconds before hiding the toast.
    // }
    */
    this.interact = function (type, body, options = {}) {
        $("#toast_area").append(getToast(type, body));
        const $toast = document.querySelector("#toast_area").lastElementChild;

        if (["danger", "warning"].includes(type) && !options.autohide) options.autohide = false;
        const toast = new Toast($toast, options);

        return new Promise((resolve) => {
            $toast.addEventListener("hidden.bs.toast", () => {
                $toast.remove();
                resolve();
            });
            toast.show();
        });
    };
};
export default new ToastArea();
